function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-166.000000, -17.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(166.000000, 17.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  fill: "#8DB2D1",
  x: 0,
  y: 0,
  width: 31,
  height: 29,
  rx: 6
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFFFF",
  cx: 7.98484848,
  cy: 14.5,
  rx: 2.34848485,
  ry: 2.33870968
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFFFF",
  cx: 15.5,
  cy: 14.5,
  rx: 2.34848485,
  ry: 2.33870968
}), /*#__PURE__*/React.createElement("ellipse", {
  fill: "#FFFFFF",
  cx: 23.0151515,
  cy: 14.5,
  rx: 2.34848485,
  ry: 2.33870968
}))));
var SvgIconDots = function SvgIconDots(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "31px",
    height: "29px",
    viewBox: "0 0 31 29",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconDots, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-dots.59512c29.svg";
export { ForwardRef as ReactComponent };